import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { fillParent, scrollingBox, footerFlex } from "utils/base-styles";
import MisinformationSearch from "features/Tools/components/MisinformationSearch";
import Footer from "components/layout/Footer";
import PageTitle from "components/layout/PageTitle";
import { FeatureHelpVideo } from "features/Support";

export default function MisinformationSearchPage() {
  return (
    <Box
      sx={{
        ...fillParent,
        ...scrollingBox,
        ...footerFlex,
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "70%" },
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
        }}
      >
        <Stack direction="row" alignItems="baseline" flexWrap="wrap" mt={3} gap={1}>
          <PageTitle mt={0}>Dubious Sources Search</PageTitle>
          <FeatureHelpVideo
            videoId="953135549"
            title="Tip: How to use Dubious Sources Search"
            showText
          />
        </Stack>
        <MisinformationSearch />
      </Box>
      <Footer sx={{ px: 0 }} />
    </Box>
  );
}
